import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import Label from '@/components/fields/Label';

export default function InputField({
  id,
  children,
  isRequired,
  position,
  className,
  disabled,
  autocomplete = 'on',
  placeholder = '',
  bgColor = 'white',
}: {
  id: string;
  children: ReactNode;
  isRequired: boolean;
  position?: 'top' | 'right';
  className?: string;
  disabled?: boolean;
  autocomplete?: string;
  placeholder?: string;
  bgColor?: string;
}): JSX.Element {
  const { register, errors } = useFormContext();
  const hasErrors = typeof errors[id] !== 'undefined';
  const isTop = position === 'top';
  const isRight = position === 'right';
  const label = (
    <Label
      id={id}
      isRequired={isRequired}
      className={`${
        !isRight ? `${isTop ? 'md:w-3/5' : 'md:w-2/5'} md:pr-4` : ''
      }`}
    >
      {children}
    </Label>
  );

  return (
    <div
      className={`mb-4 md:flex ${
        isTop ? 'flex-col' : 'md:items-center'
      } ${className}`}
    >
      {!isRight ? label : null}
      <div
        className={`${
          !isRight ? `${isTop ? 'md:w-3/5' : 'md:w-2/5 md:pl-4'}` : ''
        }`}
      >
        <div
          className={`${
            isRight ? 'flex space-x-2 items-center' : 'shadow-sm '
          } mt-2 relative rounded-md`}
        >
          <input
            id={id}
            name={id}
            className={`${isRight ? 'w-5/12 sm:w-8/12 lg:w-7/12' : 'block w-full'} ${
              hasErrors
                ? 'border-red-600'
                : 'border-gray-300 disabled:bg-gray-300'
            } form-input sm:text-sm sm:leading-5`}
            ref={register}
            disabled={disabled ? true : false}
            autoComplete={autocomplete}
            placeholder={placeholder}
            style={{ backgroundColor: bgColor }}
          />
          {isRight ? label : null}
        </div>
        {hasErrors ? (
          <p className="mt-1 text-sm text-red-600">{errors[id].message}</p>
        ) : null}
      </div>
    </div>
  );
}
